export class SC_Department {
    public static readonly HR = 1;
    public static readonly BILLING = 2;
    public static readonly SCHEDULING = 3;
    public static readonly OPERATIONS = 4;
    public static readonly COMPLIANCE = 5;

    public static readonly VALUES = [
        SC_Department.HR,
        SC_Department.BILLING,
        SC_Department.SCHEDULING,
        SC_Department.OPERATIONS,
        SC_Department.COMPLIANCE,
    ].map(it => SC_Department.fromAPI(it).remap());

    public readonly value: number;

    private constructor(value: number) {
        this.value = value;
    }

    static fromAPI(value: number | string): SC_Department {
        switch (value) {
            default:
                return new SC_Department(Number(value));
        }
    }

    static fromAPIString(value: string): SC_Department | null {
        switch (value) {
            case "department_billing":
                return new SC_Department(SC_Department.BILLING);
            case "department_compliance":
                return new SC_Department(SC_Department.COMPLIANCE);
            case "department_hr":
                return new SC_Department(SC_Department.HR);
            case "department_operations":
                return new SC_Department(SC_Department.OPERATIONS);
            case "department_scheduling":
                return new SC_Department(SC_Department.SCHEDULING);
        }
        return null;
    }

    toAPI(): number {
        return this.value;
    }

    is(value: number): boolean {
        return this.value === value;
    }

    clone(): SC_Department {
        return new SC_Department(this.value);
    }

    remap(other?: number, textOverride?: string) {
        return {
            key: other ?? this.value,
            value: textOverride ?? this.shortName,
            className: this.className,
        };
    }

    get className(): string {
        switch (this.value) {
            case SC_Department.HR:
                return "DeptHR";
            case SC_Department.BILLING:
                return "DeptBilling";
            case SC_Department.SCHEDULING:
                return "DeptScheduling";
            case SC_Department.OPERATIONS:
                return "DeptOperations";
            case SC_Department.COMPLIANCE:
                return "DeptCompliance";
            default:
                return "DeptUnknown";
        }
    }

    get shortName(): string {
        switch (this.value) {
            case SC_Department.HR:
                return "HR";
            case SC_Department.BILLING:
                return "Billing";
            case SC_Department.SCHEDULING:
                return "Scheduling";
            case SC_Department.OPERATIONS:
                return "Operations";
            case SC_Department.COMPLIANCE:
                return "Compliance";
            default:
                return "Unknown";
        }
    }
}
